import { FunctionComponent, useCallback } from 'react'
import cn from 'classnames'
import { useRouter } from 'next/navigation'

import { mktuSearchStore } from '@/store/MktuSearch.store'
import { Icon } from '@/icons'
import { ExampleClasses } from '../ExampleClasses'

import styles from './AutoClassSearch.module.scss'

type InputClassesNameProps = {
  className?: string
}
export const AutoClassSearch: FunctionComponent<InputClassesNameProps> = ({
  className,
}) => {
  const router = useRouter()

  const showPopupClassWords = useCallback(() => {
    mktuSearchStore.popupClassWords.show()
    router.push('/mktu')
  }, [router])

  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.row}>
        <button
          className={cn(className, styles.inputContainer)}
          onClick={showPopupClassWords}
        >
          <Icon name="searchSimple" className={styles.searchIcon} />
          <span className={styles.searchText}>
            Введите название товара или услуги
          </span>
        </button>
      </div>
      <ExampleClasses className={styles.examples} />
    </div>
  )
}
